/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'

export const SPEC_VERSION = 'v10'
export interface ICarriersProps {
  nextPage: boolean
  carriers: ICarrierProps[]
}

export interface ICarrierProps {
  id: number
  state?:
    | 'new'
    | 'pending'
    | 'application_submitted'
    | 'in_review'
    | 'activated'
    | 'out_of_service'
    | 'conditional'
    | 'cancelled'
    | 'other'
    | 'probation'
    | 'do_not_use'
    | 'expired_insurance'
  legalName: string | null
  mcNumber?: string | null
  dotNumber?: string | null
  phoneLabel?: string | null
  city?: string | null
  stateCode?: string | null
  postalCode?: string | null
  lastNote?: string | null
  noteCount?: number
  isBeforeActivated?: boolean
  fmcsaRating?: string | null
  insuredAmount?: number | null
  insuranceExpirationDate?: string | null
  totalShipmentsCount?: number
  qualifications?: {
    key: string
    title: string
  }[]
  carrierEquipments?: {
    key: string
    title: string
    confirmed: boolean
  }[]
  carrierManagers?: {
    id: number
    parentUserId: number
    email: string
    fullName: string
    relationshipType?: string
  }[]
}

export interface ErrorResponse {
  errors: string[]
}

export interface SuccessResponse {
  message?: string
}

export interface GetCarriersQueryParams {
  companyInfo?: string
  status?: string
  dotNumber?: string
  mcNumber?: string
  city?: string
  stateCode?: string
  miles?: string
  query?: string
  pageCount?: number
  pageSize?: number
  sortOrder?: string
  sortField?: string
}

export type GetCarriersProps = Omit<
  GetProps<ICarriersProps, unknown, GetCarriersQueryParams, void>,
  'path'
>

/**
 * Get Carriers List
 */
export const GetCarriers = (props: GetCarriersProps) => (
  <Get<ICarriersProps, unknown, GetCarriersQueryParams, void> path='/v10/carriers' {...props} />
)

export type UseGetCarriersProps = Omit<
  UseGetProps<ICarriersProps, unknown, GetCarriersQueryParams, void>,
  'path'
>

/**
 * Get Carriers List
 */
export const useGetCarriers = (props: UseGetCarriersProps) =>
  useGet<ICarriersProps, unknown, GetCarriersQueryParams, void>(`/v10/carriers`, props)

export interface DeleteBCAPathParams {
  id: string
}

export type DeleteBCAProps = Omit<
  MutateProps<SuccessResponse, ErrorResponse, void, void, DeleteBCAPathParams>,
  'path' | 'verb'
> &
  DeleteBCAPathParams

/**
 * Delete Carrier BCA
 */
export const DeleteBCA = ({ id, ...props }: DeleteBCAProps) => (
  <Mutate<SuccessResponse, ErrorResponse, void, void, DeleteBCAPathParams>
    verb='DELETE'
    path={`/v10/carriers/${id}/delete_bca`}
    {...props}
  />
)

export type UseDeleteBCAProps = Omit<
  UseMutateProps<SuccessResponse, ErrorResponse, void, void, DeleteBCAPathParams>,
  'path' | 'verb'
> &
  DeleteBCAPathParams

/**
 * Delete Carrier BCA
 */
export const useDeleteBCA = ({ id, ...props }: UseDeleteBCAProps) =>
  useMutate<SuccessResponse, ErrorResponse, void, void, DeleteBCAPathParams>(
    'DELETE',
    (paramsInPath: DeleteBCAPathParams) => `/v10/carriers/${paramsInPath.id}/delete_bca`,
    { pathParams: { id }, ...props }
  )
